<template>
  <PricingBreakdownComponent v-if="mockSubscriptions?.length" :subscriptions="mockSubscriptions" :quantity="qty" />
</template>

<script setup lang="ts">
import PricingBreakdownComponent from '../modules/PricingBreakdown/index.vue'

const props = withDefaults(defineProps<{
  interval?: 'monthly' | 'yearly' | 'halfyearly'
  qty?: number
}>(), {
  qty: 1
})

const SKU_MAP = new Map<string, string>([
  ['monthly', 'sub_premiumplus_dk_1month'],
  ['halfyearly', 'sub_premiumplus_dk_6months'],
  ['yearly', 'sub_premiumplus_dk_12months']
])

const subscriptions = ref<any>(null)

onMounted(async () => {
  const res = await fetch('https://presale.saphe.com/api/store/products/model-t')
  subscriptions.value = await res.json()
})

const mockSubscriptions = computed(() => {
  if (props.interval) {
    return (subscriptions.value || []).filter((sub: any) => sub?.properties?.sku === SKU_MAP.get(props.interval as any))
  }

  return subscriptions.value || []
})

</script>
